import styled, { css } from 'styled-components/macro';

import * as colors from 'components/common/colorConstants';

const hiddenScrollBarStyles = css`
  overflow: -moz-scrollbars-none;
  -ms-overflow-style: none;
  &::-webkit-scrollbar {
    width: 0;
  }
`;

export const Container = styled.div`
  width: 100%;
  margin-top: 10px;
  transition: 0.3s linear;
  overflow-y: scroll;
  ${hiddenScrollBarStyles}
`;

export const StatsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  background: ${colors.darkGray6};
`;
